
// Hooks
//
const buttonHook = "[js-tab-button]"
const textHook = "[js-tab-text]"
const titleHook = "[js-tab-title]"
const linkHook = "[js-tab-link]"
let curTitle;
// Classes
//
const activeClass = "active"

class Tabs {
  constructor(element) {
    this.element = element;
    this.buttons = element.querySelectorAll(buttonHook)
    this.text = element.querySelector(textHook)
    this.title = element.querySelector(titleHook)
    this.link = element.querySelector(linkHook)

    this.init();
  }

  init() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        btn.classList.add(activeClass)
        this.buttons.forEach(button => {

          btn.dataset.buttonTitle != button.dataset.buttonTitle && button.classList.remove(activeClass)
        })

        if (this.text) this.text.innerHTML = btn.dataset.text
        if (this.title) {
          this.title.innerHTML = btn.dataset.title;
          curTitle = this.title;
        } 
        if (this.link) {
          this.link.innerHTML = btn.dataset.buttonTitle
          this.link.href = btn.dataset.buttonLink

          if (!btn.dataset.buttonTitle || !btn.dataset.buttonLink) {
            this.link.classList.add('btn--hidden')
          } else {
            this.link.classList.contains('btn--hidden') && this.link.classList.remove('btn--hidden')
          }
        }

        window.scrollTo({
          top: curTitle.parentElement.getBoundingClientRect().top + window.scrollY - document.querySelector('.c-navigation').offsetHeight,
          left: 0,
          behaviour: "smooth"
        });

      })
    })
  }
}

export default Tabs;

